import Button from '@atoms/Button/Button';
import {
  StyledSubCategoryLink,
  StyledSubCategoryLinksWrapper,
} from '@molecules/SubCategoryLinks/SubCategoryLinks.styles';
import paths from '@constants/paths';
import type { CategoryData } from '@occ/api-client';

interface Props {
  categories: Array<CategoryData>;
}

const SubCategoryLinks = ({ categories }: Props) => {
  return (
    <>
      {categories.length > 0 && (
        <StyledSubCategoryLinksWrapper>
          {categories
            .filter((category): category is Required<CategoryData> => category.url !== undefined)
            .map((category) => (
              <StyledSubCategoryLink href={`${paths.CATEGORY}/${category.url}`} key={category.url}>
                <Button variant="tile" size="xsmall">
                  {category.name}
                </Button>
              </StyledSubCategoryLink>
            ))}
        </StyledSubCategoryLinksWrapper>
      )}
    </>
  );
};

export default SubCategoryLinks;
